import { combineReducers } from "redux";

import governorateReducer from "./governorate";
import uiReducer from "./ui";
import emperorTentReducer from "./emperorTent";

export const rootReducer = combineReducers({
  governorate: governorateReducer,
  ui: uiReducer,
  emperorTent: emperorTentReducer
});
